<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
        <el-table-column label="状态" align="center" width="80" v-if="$permission.canWrite()">
          <template slot-scope="{ row }">
            <span type="text" style="font-size: 14px">{{ row.IsEnable == false ? '停用' : '启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160" v-if="$permission.canWrite()">
          <template slot-scope="{ row }">
            <el-button type="text" @click.stop="edit(row)">编辑</el-button>
            <el-button type="text" @click.stop="del(row)">{{ row.IsEnable == true ? '停用' : '启用' }}</el-button>
            <el-button v-if="$permission.canWrite()" type="text" @click="copy(row)">复制</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <bom-dialog ref="bomDialog" @confirm="toCopy"></bom-dialog>
  </div>
</template>
  <script>
import curdMixins from '@/mixins/curd'
import list from '@/components/production/craftsmanship/modelbom/list'
import bomDialog from "@/views/production/craftsmanship/bom/bomDialog";

export default {
  name: 'bom',
  mixins: [curdMixins],
  components: {
    list,
    bomDialog,
  },
  data() {
    return {
      api: require('@/api/production/teMouldBom').default
    }
  },
  methods: {
    create() {
      this.toURL({
        name: 'editcommodulbom',
        params: {
          type: 'create'
        }
      })
    },
    edit(row) {
      console.log(row, 'row1')
      this.toURL({
        name: 'editcommodulbom',
        params: {
          type: 'edit',
          data: row
        }
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    del({ TemouldBomId }) {
      let id = TemouldBomId
      this.api.change({ id }).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.$refs.list.getData()
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },    
    delRows() {
      this.$refs.list.del();
    },
    copy(row) {
      this.row = row;
      this.$refs.bomDialog.open();
    },
    toCopy(data) {
      var loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.copy({ TemouldBomId: this.row.TemouldBomId, Bomno: data.Bomno }).then((res) => {
        loading.close();
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  }
}
</script>